export default __webpack_public_path__ + "static/titilliumweb-regular-webfont-52adfa8dd65badb145e36c6bc6b5f37a.eot";